import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-dark',
  templateUrl: './logo-dark.component.html',
  styleUrls: ['./logo-dark.component.scss']
})
export class LogoDarkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
